import useBootstrapData from '@/hooks/useBootstrapData'
import logSearchFormAnalytics from '@/shared-utils/log-search-form-analytics'
import { CruiseSearchForm } from '@pcln/horizon-search-form'
import { handleSubmit as handleCruiseSubmit } from '../SearchForm/utils'

function HorizonCruiseForm({ useCompactLayout = false }: { useCompactLayout?: boolean }) {
  const {
    isMobile,
    referral,
    webstats: { clientGUID: cguid },
  } = useBootstrapData()

  return (
    <CruiseSearchForm
      variant={useCompactLayout ? 'compact' : 'full'}
      isMobile={isMobile}
      onSubmit={(data) => {
        handleCruiseSubmit(data, referral, new Date())
        logSearchFormAnalytics({ cguid, pageName: 'homepage', productType: 'cruises', isMobile })
      }}
    />
  )
}

export default HorizonCruiseForm
